import type { FilterSchema, OrderingSchema } from "./types";
export function buildQueryParams(
  offset: number,
  limit: number,
  filters: FilterSchema,
  ordering: OrderingSchema
) {
  const params = new URLSearchParams({
    ...{ offset: (offset * limit).toString() },
    ...{ limit: limit.toString() },
    ...(filters && { filters: JSON.stringify(filters) }),
    ...(ordering && { ordering: JSON.stringify(ordering) }),
  });
  return params;
}

export function buildBodyParams(
  offset: number,
  limit: number,
  filters: FilterSchema,
  ordering: OrderingSchema
) {
  const params = {
    ...{ offset: (offset * limit).toString() },
    ...{ limit: limit.toString() },
    ...(filters && { filters }),
    ...(ordering && { ordering }),
  };
  return params;
}
